import type { FunctionCategory } from '@tunasong/music-lib'
import type { FC } from 'react'
import { useTheoryCopy } from '../theory-copy/use-theory-copy.js'
import styles from './function-quiz-answer-card.module.css'

const CATEGORY_LEXICON_ID: Record<FunctionCategory, string> = {
  tonic: 'function-category-tonic',
  predominant: 'function-category-predominant',
  dominant: 'function-category-dominant',
}

export type AnswerCardState = 'idle' | 'correct' | 'incorrect' | 'dimmed'

export interface FunctionQuizAnswerCardProps {
  category: FunctionCategory
  state: AnswerCardState
  onPick: (category: FunctionCategory) => void
}

/**
 * Single answer-button card for Tonic / Predominant / Dominant. State drives
 * disabled-ness and visual treatment (idle is interactive; correct / incorrect
 * / dimmed are post-answer states). The long name comes from the lexicon's
 * `displayName`; the short tag from the level-resolved `tag`.
 */
export const FunctionQuizAnswerCard: FC<FunctionQuizAnswerCardProps> = props => {
  const { category, state, onPick } = props
  const copy = useTheoryCopy(CATEGORY_LEXICON_ID[category])
  const longName = copy?.displayName ?? category
  const shortTag = copy?.tag ?? category
  const isInteractive = state === 'idle'
  const stateClass = styles[state] ?? ''
  return (
    <button
      type="button"
      className={`${styles.card} ${stateClass}`}
      disabled={!isInteractive}
      aria-pressed={state === 'correct'}
      onClick={() => onPick(category)}
    >
      <span className={styles.longName}>{longName}</span>
      <span className={styles.shortTag}>{shortTag}</span>
    </button>
  )
}
